import React from "react";
import { apiSendMultipleReminders } from "Root/api/apiProfile";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { useDispatch } from "react-redux";
import toastService from "Root/profile/toastService";
import styles from "./styles.module.css";

function ReferralTable(props) {
  const dispatch = useDispatch();

  async function sendReminders(recipients) {
    /*
    Send email reminder to pending referrals.

    Inputs
      -recipients: List of strings of emails to send reminders to
    */
    dispatch(setGlobalLoading(true));
    try {
      const resp = await apiSendMultipleReminders({ recipients });
      dispatch(setGlobalLoading(false));
      const { msg } = resp;

      if (msg === "success") {
        if (recipients.length === 1) {
          toastService.successMessage("Your reminder email was sent!");
        } else {
          toastService.successMessage("Your reminder emails were sent!");
        }
      } else {
        toastService.errorMessage("Something went wrong, please try again");
      }
    } catch (e) {
      toastService.errorMessage("Something went wrong, please try again");
    }
  }

  return (
    <>
      {props.unconvertedData.length > 0 && (
        <div>
          <hr className={styles.referralHr} />
          <table className={styles.referralTable}>
            <thead>
              <tr>
                <th className={styles.refTableHeader}>Pending Referrals</th>
                <th className={`${styles.refTableHeader} ${styles.cta}`}>
                  <button className={styles.refBtn} onClick={() => sendReminders(props.unconvertedData)} type="button">
                    Remind All
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {props.unconvertedData.map((item) => (
                <tr key={Math.random()}>
                  <td style={{ textAlign: "left" }}>{item}</td>
                  <td>
                    <button className={styles.refBtn} onClick={() => sendReminders([`${item}`])} type="button">
                      Send Reminder
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {props.purchaseData.length > 0 && (
        <div>
          <hr className={styles.referralHr} />
          <table>
            <tbody>
              <thead>
                <tr>
                  <th className={styles.refTableHeader}>Completed Referrals</th>
                </tr>
              </thead>
              {props.purchaseData.map((item) => (
                <tr style={{ width: "100%", textAlign: "center", border: "none" }} key={Math.random()}>
                  <td style={{ textAlign: "left" }}>{item}</td>
                  <td style={{ textAlign: "right" }} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {props.purchaseData.length === 0 && props.unconvertedData.length === 0 && (
        <h5
          style={{
            textAlign: "center",
          }}
        >
          You have not referred any friends yet!
        </h5>
      )}
    </>
  );
}

export default ReferralTable;
